import PropTypes from 'prop-types';
import cssVariables from 'src/common/styles/variables';

/* eslint-disable max-len */
const VolumeControlIcon = ({
  width,
  height,
  viewBox,
  onClick,
  className,
  fillColor,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox || '3 3 17 17'}
    className={className}
    data-testid="unmuted"
    onClick={onClick}
  >
    <path
      d="M9.87,4.12a.68.68,0,0,1,1.05.5V19.38a.68.68,0,0,1-1.05.5L7,16H3.5a.49.49,0,0,1-.5-.49V8.53A.49.49,0,0,1,3.5,8H7Zm7.85,15.75-1-1a.45.45,0,0,1,0-.63,9.25,9.25,0,0,0,.06-12.35l-.06-.07a.45.45,0,0,1,0-.63l1-1a.46.46,0,0,1,.66,0,11.6,11.6,0,0,1,0,15.7A.46.46,0,0,1,17.72,19.87Zm-3.36-3.36-1-1a.46.46,0,0,1,0-.62,4.5,4.5,0,0,0,.12-5.59l-.12-.15a.46.46,0,0,1,0-.62l1-1a.47.47,0,0,1,.68,0,6.89,6.89,0,0,1,0,9A.47.47,0,0,1,14.36,16.51Z"
      fill={fillColor || cssVariables['--secondary-color-5']}
      fillRule="evenodd"
    />
    <g opacity="0.11">
      <rect width="24" height="24" fill="none" />
    </g>
  </svg>
);

VolumeControlIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
  fillColor: PropTypes.string,
};

export default VolumeControlIcon;
